import { createAction } from "redux-actions";

export const actionTypes = {
    GET_VIET_GUY_CONFIG: 'appConfig/GET_VIET_GUY_CONFIG',
    UPDATE_VIET_GUY_CONFIG: 'appConfig/UPDATE_VIET_GUY_CONFIG',
}

export const actions = {
    getVietGuyConfig: createAction(actionTypes.GET_VIET_GUY_CONFIG),
    updateVietGuyConfig: createAction(actionTypes.UPDATE_VIET_GUY_CONFIG),
}